import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from '../../../services/constants-service';
import { ObservableRequestService } from '../../../services/observable-request.service';

/**
 * Service to save Time Keeping Details.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
@Injectable()
export class TimesheetService {
    constructor(private requestService: ObservableRequestService) { }

    saveTimesheet(body: Object): Observable<any> {
        const saveTimesheetUrl = ConstantsService.SAVE_TIMESHEET;
        return this.requestService.postRequest(saveTimesheetUrl,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };
}



// WEBPACK FOOTER //
// ./src/app/header/navigationbar/timesheethandler/timesheet.service.ts